import React from "react";

export const getVisiblePages = (currentPage, totalPages, maxButtons = 5) => {
    if (!totalPages || totalPages <= 0) return [];

    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + maxButtons - 1);

    if (end - start < maxButtons - 1) {
        start = Math.max(1, end - maxButtons + 1);
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
        pages.push(i);
    }

    return pages;
};